module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei4.svg";